<i18n>
zh:
    new1: 行业新闻
    title1: 企业简介
    title2: 企业新闻
    title3: 员工风采
    title4: 供热须知
    title5: 联系我们
ru:
    new1: Новости отрасли
    title1: Корпоративный профиль
    title2: Динамика предприятий
    title3: Стиль работы
    title4: Здравый смысл отопления
    title5: Свяжитесь с нами
</i18n>
<template>
    <div class="home">
        <template v-if="config.menus && config.menus.length > 0">
            <NavigationMobile/>
        </template>
        <template v-if="config.index_banner && config.index_banner.length > 0">
            <swiper class="banner banner1" :options="options">
                <swiper-slide v-for="item in config.index_banner" :key="item.id" :style="`background-image: url(${item.image});`">
                    <router-link v-if="item.url" :to="item.url"></router-link>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </template>
        <div class="main">
            <!-- 行业新闻 -->
            <div class="news_wrap" v-if="news1.length > 0">
                <p class="title">{{$t('new1')}}：</p>
                <swiper class="news" :options="news1Options">
                    <swiper-slide v-for="item in news1" :key="item.id">
                        <router-link :to="`/list/12/detail/${item.id}`">{{item.title}}</router-link>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="box">
                <!-- 轮播 -->
                <swiper class="banner banner2" :options="options">
                    <swiper-slide v-for="item in config.index_banner1" :key="item.id" :style="`background-image: url(${item.image});`">
                        <router-link v-if="item.url" :to="item.url"></router-link>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
                <!-- 企业简介 -->
                <router-link class="title" to="/detail/2"><p>{{$t('title1')}}</p></router-link>
                <div class="content" v-text="config.company_profile"></div>
            </div>
            <!-- 企业新闻 -->
            <div class="box">
                <router-link class="title" to="/list/10"><p>{{$t('title2')}}</p></router-link>
                <div class="list">
                    <router-link class="item" v-for="item in news2" :key="item.id" :to="`/list/10/detail/${item.id}`">
                        <p class="tit">{{item.title}}</p>
                        <p class="time">{{item.time}}</p>
                    </router-link>
                </div>
            </div>
            <div class="box_group">
                <router-link class="item" to="/list/17">
                    <img src="@/assets/images/0001.jpg" alt=""/>
                    <div class="title"><p>{{$t('title3')}}</p></div>
                </router-link>
                <router-link class="item" to="/detail/23">
                    <img src="@/assets/images/0002.jpg" alt=""/>
                    <div class="title"><p>{{$t('title4')}}</p></div>
                </router-link>
                <router-link class="item" to="/repair/20">
                    <img src="@/assets/images/0003.jpg" alt=""/>
                    <div class="title"><p>{{$t('title5')}}</p></div>
                </router-link>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import NavigationMobile from './navigationMobile.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Footer from './footer.vue';
export default {
    name: "homeMobile",
    data() {
        return {
            options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                autoplay: {
                    disableOnInteraction: false
                },
            },
            news1: [],
            news1Options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                direction: 'vertical',
                autoplay: {
                    disableOnInteraction: false
                },
            },
            desc: {
                title: '',
                content: ''
            },
            news2: [],
        };
    },
    computed: {
        ...mapState(['config']),
    },
    components: {
        NavigationMobile,
        swiper,
        swiperSlide,
        Footer,
        
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {},
    methods: {
        getData(){
            // 行业新闻
            this.$store.dispatch('getList', {
                id: 12,
                page: 1,
                limit: 4,
            }).then((result)=>{
                this.news1 = result.list;
            });
            // 企业新闻
            this.$store.dispatch('getList', {
                id: 10,
                page: 1,
                limit: 4,
            }).then((result)=>{
                this.news2 = result.list;
            });
        }
    },
};
</script>

<style scoped lang="scss">
.banner{
    &.banner1{
        height: 5.2rem;
    }
    &.banner2{
        height: 4.4rem;
    }
    .swiper-slide{
        background-size: cover;
        background-position: center;
        a{
            width: 100%;
            height: 100%;
            display: block;
        }
    }
}
.main{
    padding: .4rem;
}
.news_wrap{
    display: flex;
    height: .6rem;
    line-height: .6rem;
    border: 1px solid #e8eaed;
    border-radius: .1rem;
    padding: 0 .2rem;
    margin-bottom: .4rem;
    .title{
        white-space: nowrap;
        font-size: .28rem;
    }
    .news{
        flex: 1;
        height: 100%;
        font-size: .24rem;
        .swiper-slide{
            a{
                display: block;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }
    }
}
.box{
    border: 1px solid #e8eaed;
    border-radius: .1rem;
    margin-bottom: .4rem;
    .title{
        border-bottom: 1px solid #e8eaed;
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .3rem;
        font-size: .36rem;
        color: #1953b3;
        font-weight: bold;
        &::after{
            content: "";
            width: .5rem;
            height: .5rem;
            background: url('~@/assets/images/001.png') no-repeat center/cover;
        }
    }
    .content{
        color: #2c2c2c;
        font-size: .24rem;
        padding: .2rem;
        line-height: 2;
        text-indent: 2em;
    }
    .list{
        padding: .4rem;
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: .24rem;
            line-height: .3rem;
            margin-bottom: .3rem;
            &:last-child{
                margin-bottom: 0;
            }
            .tit{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            .time{
                white-space: nowrap;
                color: #9c9c9c;
                padding-left: .4rem;
                background: url('~@/assets/images/1_28.png') no-repeat;
                background-position: center left;
                background-size: .26rem;
                margin-left: .2rem;
            }
        }
    }
}
.box_group{
    display: flex;
    justify-content: space-between;
    .item{
        width: 2rem;
        border: 1px solid #e8eaed;
        border-radius: .1rem;
        .title{
            // border-bottom: 1px solid #e8eaed;
            height: .8rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .1rem;
            font-size: .28rem;
            color: #1953b3;
            font-weight: bold;
            p{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            &::after{
                flex-shrink: 0;
                content: "";
                width: .4rem;
                height: .4rem;
                background: url('~@/assets/images/001.png') no-repeat center/cover;
            }
        }
    }
}
</style>